module.exports = __webpack_public_path__ + "img/BRCA4_Treg.39692b33.png";